import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { AppPanelShell } from '../../../components/layout/AppPanelShell';
import { CWY_COLORS } from '../../../theme/colors';

interface BookingShellProps {
  displayName?: string;
  loading?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const BookingShell: React.FC<BookingShellProps> = ({ displayName, loading, children, footer }) => (
  <AppPanelShell
    title="Appointments"
    subtitle={displayName ? `with ${displayName}` : undefined}
    footer={!loading ? footer : undefined}
  >
    {loading ? (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 300,
          px: 2,
          py: 3,
        }}
      >
        <CircularProgress sx={{ color: CWY_COLORS.red }} />
      </Box>
    ) : (
      <Box sx={{ px: { xs: 2, sm: 3 }, py: 3 }}>{children}</Box>
    )}
  </AppPanelShell>
);

export default BookingShell;
